<template>
  <div :class="item.is_customizable >= 1 ? 'item-wrapper media-customization' : 'item-wrapper'">
    <div :class="'item_detail ' + noImgClass + ' ' + layoutClass">
      <!-----Layout-1 Start---->
      <div class="media" v-if="itemlayout == '1'">

        <a :href="pagename == 'itemslist' || pagename == 'qr'
          ? 'javascript:void(0)'
          : '/outlet/' +
          (isPickupDelivery == '1'
            ? 'delivery/'
            : isPickupDelivery == '0'
              ? 'takeaway/'
              : isPickupDelivery == '2'
                ? 'reservation/'
                : '') +
          slug +
          '#item' +
          menuId
          " id="element" class="btn btn-default show-modal" @click="productModal(item)">
          <div class="media-body">
            <div class="veg" v-if="item.item_type == '0'"><span></span></div>
            <div class="non-veg" v-if="item.item_type == '1'">
              <img class="non-veg-img" src="@/assets/images/non_veg.png" />
            </div>
            <h5 class="mt-0 mr-2 item-name">{{ item.item_name }}</h5>
            <div v-if="freeBie">
              <span class="mt-2 d-inline-block item-price strikeout" v-if="item.display_price > 0"><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{ parseFloat(item.display_price).toFixed(2)}}</span>
              <span class="d-inline-block item-price" style="color: #27ae60">Free</span>

            </div>
            <div class="tags-list cusinin-tag-list mb-1" v-if="item.menu_item_tags && item.menu_item_tags.length > 0">
              <ul>
                <li v-for="(tag, i) in item.menu_item_tags" :key="i" :class="tag.name.toLowerCase()" :style="{
                  background: tag.background_color + '!important',
                  color: tag.text_color + '!important',
                }">
                  {{ tag.name }}
                </li>
              </ul>
            </div>
            <p class="mb-0 mt-2 item-descr" v-if="item.item_description">
              {{
                item.item_description && item.item_description.length > 80
                  ? item.item_description.substring(0, 80) + ".."
                  : item.item_description
              }}
            </p>
            <div class="tags-list mb-1" v-if="
              getOfferes(item.item_id) && getOfferes(item.item_id).length > 0
            ">
              <ul>
                <template v-for="(tag, i) in getOfferes(item.item_id)">
                  <li :key="i" class="fw-bolder" v-if="tag.coupon_type == couponTypes.BOGO">
                    {{ tag.title }}
                  </li>
                </template>
              </ul>
            </div>
            <div class="prc-show" v-if="freeBie">
              <span class="mt-2 d-inline-block item-price" style="color: #27ae60">Free</span>
              <!-- <span class="mt-2 d-inline-block item-price" v-if="item.display_price != '0'"><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{parseFloat(item.display_price).toFixed(2)}}</span> -->
              <span class="mt-2 d-inline-block item-price strikeout" v-if="item.mrp > 0 || item.display_price > 0"><span
                  v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                    item.display_price < item.mrp ? parseFloat(item.mrp).toFixed(2) :
                      parseFloat(item.display_price).toFixed(2) }}</span>
            </div>

            <div class="prc-show" v-else>
              <span class="mt-2 d-inline-block item-price" v-if="item.display_price != '0'"><span
                  v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                    checkForFlatPrice(item.item_id,
                      item.display_price) }}</span>
              <span class="mt-2 d-inline-block item-price strikeout" v-if="
                item.mrp != item.price ||
                checkForFlatPrice(item.item_id, item.display_price) <
                item.display_price
              "><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                checkForFlatPrice(item.item_id, item.display_price) < item.display_price ?
                  parseFloat(item.display_price).toFixed(2) : parseFloat(item.mrp).toFixed(2) }}</span>
            </div>
          </div>
        </a>
        <!--Image with button start----->
        <div class="img-btn">
          <div class="item-img itemimg-squre" :class="!item.image ? 'img-not-found' : ''">
            <img :src="item.image ? item.image : imageErrorHandle" @error="imageErrorHandle" />
          </div>
          <div :class="item.is_customizable >= 1 ? 'customize-label' : 'pgnme-cls'" v-if="pagename != 'qr'">
            <div v-if="!closeLabel">
              <div v-if="item.is_sold_out == '0'" class="sold-de">
                <div v-if="item.is_customizable >= '1'" class="csm-de">
                  <button class="add-to-cart btn btn-outline-warning btn-sm" @click="productModal(item)"
                    v-if="checkInCart(item.item_id) || this.freeBie">
                    {{ $t("Add") }}
                  </button>
                  <div v-else>
                    <div>
                      <div class="quantityInc 1">
                        <div class="number d-flex align-items-center">
                          <span class="minus d-flex justify-content-center align-items-center"
                            @click="minusItem(item)">-</span>
                          <input type="text" :value="cart.reduce(
                            (a, c) =>
                              a +
                              (c.item_id == item.item_id ? c.quantity : 0),
                            0
                          )
                            " readonly />
                          <span class="plus d-flex justify-content-center align-items-center"
                            @click="productModal(item)">+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="icus">
                  <button v-if="item.is_sold_out == '0' && (checkInCart(item.item_id) || this.freeBie)"
                    class="add-to-cart btn btn-outline-warning btn-sm" @click="addProductToCart(item)">
                    {{ $t("Add") }}
                  </button>
                  <div v-else>
                    <div class="quantityInc 2">
                      <div class="number d-flex align-items-center">
                        <span class="minus d-flex justify-content-center align-items-center"
                          @click="minusItem(item)">-</span>
                        <input type="text" :value="cart.reduce(
                          (a, c) =>
                            a +
                            (c.item_id == item.item_id ? c.quantity : 0),
                          0
                        )
                          " readonly />
                        <span class="plus d-flex justify-content-center align-items-center"
                          @click="plusItem(item)">+</span>
                      </div>
                    </div>
                  </div>
                </div>
                <p v-if="item.is_customizable" class="tag-customize tagcust-nw">
                  {{ $t("Customisable") }}
                </p>
              </div>
              <div v-else class="sold-bt">
                <button v-if="item.is_sold_out != '0'" class="sold add-to-cart btn btn-outline-warning btn-sm">
                  {{ $t("Sold Out") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--Image with button end----->
      </div>
      <!-----Layout-1 End---->
      <!-----Layout-2 Start---->
      <div class="media" v-if="itemlayout == '2'">
        <!-- <a :href="(pagename=='itemslist' || pagename == 'qr')?'javascript:void(0)':'/outlet/'+(isPickupDelivery == '1'?'delivery/':isPickupDelivery == '0'?'takeaway/':isPickupDelivery == '2'?'reservation/':'')+ slug+'#item'+menuId" id="element" class="btn btn-default show-modal" @click="productModal(item)"> -->
        <div id="element" class="btn btn-default show-modal cust-modal-width">
          <div class="media-body" @click="productModal(item)">
            <div class="veg" v-if="item.item_type == '0'"><span></span></div>
            <div class="non-veg" v-if="item.item_type == '1'">
              <img class="non-veg-img" src="@/assets/images/non_veg.png" />
            </div>
            <h5 class="mt-0 mr-5 item-name">{{ item.item_name }}</h5>
            <div class="tags-list mb-1" v-if="item.menu_item_tags && item.menu_item_tags.length > 0">
              <ul>
                <li v-for="(tag, i) in item.menu_item_tags" :key="i" :class="tag.name.toLowerCase()" :style="{
                  background: tag.background_color + '!important',
                  color: tag.text_color + '!important',
                }">
                  {{ tag.name }}
                </li>
              </ul>
            </div>
            <div class="prc-show">
              <span class="mt-2 d-inline-block item-price" v-if="item.display_price != '0'"><span
                  v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                    parseFloat(item.display_price).toFixed(2) }}</span>
              <span class="mt-2 d-inline-block item-price strikeout" v-if="item.mrp != item.price"><span
                  v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                    parseFloat(item.mrp).toFixed(2)
                  }}</span>
            </div>
          </div>
          <p class="mb-0 mt-2 item-descr" v-if="item.item_description">
            <span :id="'shortdec' + item.item_id" style="display: block">
              {{ item.item_description.substring(0, 54) }}
              <a v-if="
                item.item_description && item.item_description.length > 54
              " href="javascript:void(0)" @click="readMore(item.item_id)" class="readmore">...more</a>
            </span>
            <span :id="'moredesc' + item.item_id" style="display: none">{{ item.item_description }}
              <!-- <a href="javascript:void(0)" @click="readMore(item.item_id)" class="readless">less</a> -->
            </span>
          </p>
        </div>
        <!-- </a> -->
        <!--Image with button start----->
        <div class="img-btn">
          <div class="item-img itemimg-squre" v-if="!imgError">
            <img :src="item.image" @error="onImgError()" />
          </div>
          <a :href="pagename == 'itemslist' || pagename == 'qr'
            ? 'javascript:void(0)'
            : '/outlet/' +
            (isPickupDelivery == '1'
              ? 'delivery/'
              : isPickupDelivery == '0'
                ? 'takeaway/'
                : isPickupDelivery == '2'
                  ? 'reservation/'
                  : '') +
            slug +
            '#item' +
            menuId
            " id="element" class="btn btn-default show-modal" @click="productModal(item)">
            <div class="media-body">
              <div class="d-flex align-items-center">
                <div class="veg" v-if="item.item_type == '0'">
                  <span></span>
                </div>
                <div class="non-veg" v-if="item.item_type == '1'">
                  <img class="non-veg-img" src="@/assets/images/non_veg.png" />
                </div>
                <h5 class="mt-0 mr-lg-2 mb-0 mr-0 item-name">
                  {{ item.item_name }}
                </h5>
              </div>
              <div class="tags-list mb-1" v-if="item.menu_item_tags && item.menu_item_tags.length > 0">
                <ul>
                  <li v-for="(tag, i) in item.menu_item_tags" :key="i" :class="tag.name.toLowerCase()" :style="{
                    background: tag.background_color + '!important',
                    color: tag.text_color + '!important',
                  }">
                    {{ tag.name }}
                  </li>
                </ul>
              </div>
              <p class="mb-0 mt-2 item-descr" v-if="item.item_description">
                {{
                  item.item_description && item.item_description.length > 80
                    ? item.item_description.substring(0, 80) + ".."
                    : item.item_description
                }}
              </p>
              <div class="tags-list mb-1" v-if="
                getOfferes(item.item_id) &&
                getOfferes(item.item_id).length > 0
              ">
                <ul>
                  <li v-for="(tag, i) in getOfferes(item.item_id)" :key="i" class="fw-bolder">
                    {{ tag.title }}
                  </li>
                </ul>
              </div>
              <div class="prc-show" v-if="freeBie">
                <span class="mt-2 d-inline-block item-price" style="color: #27ae60">Free</span>
                <!-- <span class="mt-2 d-inline-block item-price" v-if="item.display_price != '0'"><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{parseFloat(item.display_price).toFixed(2)}}</span> -->
                <span class="mt-2 d-inline-block item-price strikeout"
                  v-if="item.mrp > 0 || item.display_price > 0"><span v-html="$auth.setting && $auth.setting.currency"
                    class="currency"></span>{{
                      item.display_price < item.mrp ? parseFloat(item.mrp).toFixed(2) :
                        parseFloat(item.display_price).toFixed(2) }}</span>
              </div>

              <div class="prc-show" v-else>
                <span class="mt-2 d-inline-block item-price" v-if="item.display_price != '0'"><span
                    v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                      parseFloat(item.display_price).toFixed(2) }}</span>
                <span class="mt-2 d-inline-block item-price strikeout" v-if="item.mrp != item.price"><span
                    v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                      parseFloat(item.mrp).toFixed(2) }}</span>
              </div>
            </div>
          </a>
          <!--Image with button start----->
          <div class="img-btn">
            <div class="pgnme-cls" v-if="pagename != 'qr'">
              <div v-if="!closeLabel">
                <div v-if="item.is_sold_out == '0'" class="sold-de">
                  <div v-if="item.is_customizable >= '1'" class="csm-de">
                    <button class="add-to-cart btn btn-outline-warning btn-sm" @click="productModal(item)"
                      v-if="checkInCart(item.item_id)">
                      {{ $t("Add") }}
                    </button>
                    <div v-else>
                      <div>
                        <div class="quantityInc 1">
                          <div class="number d-flex align-items-center">
                            <span class="minus d-flex justify-content-center align-items-center"
                              @click="minusItem(item)">-</span>
                            <input type="text" :value="cart.reduce(
                              (a, c) =>
                                a +
                                (c.item_id == item.item_id
                                  ? c.quantity
                                  : 0),
                              0
                            )
                              " readonly />
                            <span class="plus d-flex justify-content-center align-items-center"
                              @click="productModal(item)">+</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="icus">
                    <button v-if="
                      item.is_sold_out == '0' && checkInCart(item.item_id)
                    " class="add-to-cart btn btn-outline-warning btn-sm" @click="addProductToCart(item)">
                      {{ $t("Add") }}
                    </button>
                    <div v-else>
                      <div class="quantityInc 2">
                        <div class="number d-flex align-items-center">
                          <span class="minus d-flex justify-content-center align-items-center"
                            @click="minusItem(item)">-</span>
                          <input type="text" :value="cart.reduce(
                            (a, c) =>
                              a +
                              (c.item_id == item.item_id ? c.quantity : 0),
                            0
                          )
                            " readonly />
                          <span class="plus d-flex justify-content-center align-items-center"
                            @click="plusItem(item)">+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="item.is_customizable" class="tag-customize tagcust-nw">
                    {{ $t("Customisable") }}
                  </p>
                </div>
                <div v-else class="sold-bt">
                  <button v-if="item.is_sold_out != '0'" class="sold add-to-cart btn btn-outline-warning btn-sm">
                    {{ $t("Sold Out") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--Image with button end----->
        </div>
        <!-----Layout-1 End---->
        <!-----Layout-2 Start---->
        <div class="media" v-if="itemlayout == '2'">
          <!-- <a :href="(pagename=='itemslist' || pagename == 'qr')?'javascript:void(0)':'/outlet/'+(isPickupDelivery == '1'?'delivery/':isPickupDelivery == '0'?'takeaway/':isPickupDelivery == '2'?'reservation/':'')+ slug+'#item'+menuId" id="element" class="btn btn-default show-modal" @click="productModal(item)"> -->
          <div id="element" class="btn btn-default show-modal cust-modal-width">
            <div class="media-body" @click="productModal(item)">
              <div class="d-flex align-item-center">
                <div class="veg" v-if="item.item_type == '0'">
                  <span></span>
                </div>
                <div class="non-veg" v-if="item.item_type == '1'">
                  <img class="non-veg-img" src="@/assets/images/non_veg.png" />
                </div>
                <h5 class="mt-0 mr-5 item-name">{{ item.item_name }}</h5>
              </div>
              <div class="tags-list mb-1" v-if="item.menu_item_tags && item.menu_item_tags.length > 0">
                <ul>
                  <li v-for="(tag, i) in item.menu_item_tags" :key="i" :class="tag.name.toLowerCase()" :style="{
                    background: tag.background_color + '!important',
                    color: tag.text_color + '!important',
                  }">
                    {{ tag.name }}
                  </li>
                </ul>
              </div>
              <div class="prc-show">
                <span class="mt-2 d-inline-block item-price" v-if="item.display_price != '0'"><span
                    v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                      parseFloat(item.display_price).toFixed(2) }}</span>
                <span class="mt-2 d-inline-block item-price strikeout" v-if="item.mrp != item.price"><span
                    v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                      parseFloat(item.mrp).toFixed(2) }}</span>
              </div>
            </div>
            <p class="mb-0 mt-2 item-descr" v-if="item.item_description">
              <span :id="'shortdec' + item.item_id" style="display: block">
                {{ item.item_description.substring(0, 54) }}
                <a v-if="
                  item.item_description && item.item_description.length > 54
                " href="javascript:void(0)" @click="readMore(item.item_id)" class="readmore">...more</a>
              </span>
              <span :id="'moredesc' + item.item_id" style="display: none">{{ item.item_description }}
                <!-- <a href="javascript:void(0)" @click="readMore(item.item_id)" class="readless">less</a> -->
              </span>
            </p>
          </div>
          <!-- </a> -->
          <!--Image with button start----->
          <div class="img-btn">
            <div class="item-img itemimg-squre" v-if="!imgError">
              <img :src="item.image" @error="onImgError()" />
            </div>
            <div class="pgnme-cls" v-if="pagename != 'qr'">
              <div v-if="!closeLabel">
                <div v-if="item.is_sold_out == '0'" class="sold-de">
                  <div v-if="item.is_customizable >= '1'" class="csm-de">
                    <button class="add-to-cart btn btn-outline-warning btn-sm small-add" @click="productModal(item)"
                      v-if="checkInCart(item.item_id)">
                      {{ $t("Add") }}
                    </button>
                    <div v-else>
                      <div>
                        <div class="quantityInc 1">
                          <div class="number d-flex align-items-center">
                            <span class="minus d-flex justify-content-center align-items-center"
                              @click="minusItem(item)">-</span>
                            <input type="text" :value="cart.reduce(
                              (a, c) =>
                                a +
                                (c.item_id == item.item_id
                                  ? c.quantity
                                  : 0),
                              0
                            )
                              " readonly />
                            <span class="plus d-flex justify-content-center align-items-center"
                              @click="productModal(item)">+</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="icus">
                    <button v-if="
                      item.is_sold_out == '0' && checkInCart(item.item_id)
                    " class="add-to-cart btn btn-outline-warning btn-sm small-add" @click="addProductToCart(item)">
                      {{ $t("Add") }}
                    </button>
                    <div v-else>
                      <div class="quantityInc 2">
                        <div class="number d-flex align-items-center">
                          <span class="minus d-flex justify-content-center align-items-center"
                            @click="minusItem(item)">-</span>
                          <input type="text" :value="cart.reduce(
                            (a, c) =>
                              a +
                              (c.item_id == item.item_id ? c.quantity : 0),
                            0
                          )
                            " readonly />
                          <span class="plus d-flex justify-content-center align-items-center"
                            @click="plusItem(item)">+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="item.is_customizable" class="tag-customize tagcust-nw">
                    {{ $t("Customisable") }}
                  </p>
                </div>
                <div v-else class="sold-bt">
                  <button v-if="item.is_sold_out != '0'"
                    class="sold add-to-cart btn btn-outline-warning btn-sm btn--sold">
                    {{ $t("Sold Out") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--Image with button end----->
        </div>
        <!-----Layout-2 End---->
        <!-----Layout-3 Start---->
        <div class="media" v-if="itemlayout == '3'">
          <div class="image-sec">
            <div class="item-img" v-if="!imgError">
              <img :src="item.image" @error="onImgError()" />
            </div>
          </div>
          <div nme-sec>
            <a :href="pagename == 'itemslist'
              ? 'javascript:void(0)'
              : '/outlet/' +
              (isPickupDelivery == '1'
                ? 'delivery/'
                : isPickupDelivery == '0'
                  ? 'takeaway/'
                  : isPickupDelivery == '2'
                    ? 'reservation/'
                    : '') +
              slug +
              '#item' +
              menuId
              " id="element" class="btn btn-default show-modal" @click="productModal(item)">
              <div class="media-body">
                <div class="d-flex align-item-center">
                  <div class="veg" v-if="item.item_type == '0'">
                    <span></span>
                  </div>
                  <div class="non-veg" v-if="item.item_type == '1'">
                    <img class="non-veg-img" src="@/assets/images/non_veg.png" />
                  </div>
                  <h5 class="mt-0 mr-5 item-name">{{ item.item_name }}</h5>
                </div>
                <div class="tags-list mb-1" v-if="item.menu_item_tags && item.menu_item_tags.length > 0">
                  <ul>
                    <li v-for="(tag, i) in item.menu_item_tags" :key="i" :class="tag.name.toLowerCase()" :style="{
                      background: tag.background_color + '!important',
                      color: tag.text_color + '!important',
                    }">
                      {{ tag.name }}
                    </li>
                  </ul>
                </div>
                <p class="mb-0 mt-2 item-descr" v-if="item.item_description">
                  {{
                    item.item_description && item.item_description.length > 80
                      ? item.item_description.substring(0, 80) + ".."
                      : item.item_description
                  }}
                </p>
              </div>
            </a>
          </div>
          <div class="prc-btn-sec">
            <div class="prc-show">
              <span class="mt-2 d-inline-block item-price" v-if="item.display_price != '0'"><span
                  v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                    parseFloat(item.display_price).toFixed(2) }}</span>
              <span class="mt-2 d-inline-block item-price strikeout" v-if="item.mrp != item.price"><span
                  v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                    parseFloat(item.mrp).toFixed(2)
                  }}</span>
            </div>
            <div v-if="!closeLabel">
              <div v-if="item.is_sold_out == '0'" class="sold-de">
                <div v-if="item.is_customizable >= '1'" class="csm-de">
                  <button class="add-to-cart btn btn-outline-warning btn-sm small-add" @click="productModal(item)"
                    v-if="checkInCart(item.item_id)">
                    {{ $t("Add") }}
                  </button>
                  <div v-else>
                    <div>
                      <div class="quantityInc 1">
                        <div class="number d-flex align-items-center">
                          <span class="minus d-flex justify-content-center align-items-center"
                            @click="minusItem(item)">-</span>
                          <input type="text" :value="cart.reduce(
                            (a, c) =>
                              a +
                              (c.item_id == item.item_id ? c.quantity : 0),
                            0
                          )
                            " readonly />
                          <span class="plus d-flex justify-content-center align-items-center"
                            @click="productModal(item)">+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="icus">
                  <button v-if="item.is_sold_out == '0' && checkInCart(item.item_id)"
                    class="add-to-cart btn btn-outline-warning btn-sm" @click="addProductToCart(item)">
                    {{ $t("Add") }}
                  </button>
                  <div v-else>
                    <div class="quantityInc 2">
                      <div class="number d-flex align-items-center">
                        <span class="minus d-flex justify-content-center align-items-center"
                          @click="minusItem(item)">-</span>
                        <!-- <input type="text" :value="cartItem.quantity" /> -->
                        <input type="text" :value="cart.reduce(
                          (a, c) =>
                            a +
                            (c.item_id == item.item_id ? c.quantity : 0),
                          0
                        )
                          " readonly />
                        <span class="plus d-flex justify-content-center align-items-center"
                          @click="plusItem(item)">+</span>
                      </div>
                    </div>
                  </div>
                </div>
                <p v-if="item.is_customizable" class="tag-customize tagcust-nw">
                  {{ $t("Customisable") }}
                </p>
              </div>
              <div v-else class="sold-bt">
                <button v-if="item.is_sold_out != '0'" class="sold add-to-cart btn btn-outline-warning btn-sm">
                  {{ $t("Sold Out") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-----Layout-2 End---->
      <!--Alert Modal start-->
      <AlertModal v-if="isAlert" :DisplayAlertData="AlertData" v-on:modalClose="onModalCloseFun"></AlertModal>
      <!--Alert Modal End-->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AlertModal from "../components/AlertModal.vue";
import { CouponTypes,imageErrorHandle } from "../helper/helper";

export default {
  props: [
    "item",
    "menuId",
    "currencys",
    "restaurantID",
    "restaurant_on_off",
    "pagename",
    "slug",
    "itemlayout",
    "freeBie",
  ],
  components: { AlertModal },
  data() {
    return {
      imageErrorHandle: imageErrorHandle,
      couponTypes: CouponTypes,
      imgError: "",
      productId: "",
      noImgClass: "",
      closeLabel: false,
      isAlert: false,
      AlertData: {},
      tempProduct: {},
      layoutClass: "",
      // offer:[],
      rest_offer: [],
    };
  },
  mounted() {
    let itemSlug = this.item.item_name
      .replaceAll(/[^a-zA-Z ]/g, "")
      .replaceAll(" ", "-")
      .toLowerCase();
    if (
      this.$route.params.item_slug &&
      this.$route.params.item_slug == itemSlug
    ) {
      this.productModal(this.item);
    }
    //Restaurant close or schedule for
    if (this.restaurant_on_off == "0") {
      this.closeLabel = true;
    } else {
      this.closeLabel = false;
    }
    if (this.itemlayout == "3" || this.itemlayout == "2") {
      this.layoutClass = "secondlayout";
    }

    if (this.offers && this.offers.length > 0) {
      this.rest_offer = [...this.offers];
      // this.offer = [... this.offers];
    }
  },

  watch: {
    // offers are persisted in store, use latest offers once loaded
    offers: function () {
      this.rest_offer = [...(this.offers || [])];
    },
  },

  computed: {
    ...mapGetters("product", ["cart", "offers"]),
    ...mapGetters("order", ["isPickupDelivery"]),
  },

  methods: {
    ...mapActions("product", ["addProductToCart", "removeProductFromCart"]),
    ...mapMutations("product", [
      "decrementProductInventary",
      "IncrementItemQuantity",
      "clearCartItems",
    ]),

    checkForFlatPrice(itemId, price) {
      let final = parseFloat(price).toFixed(2);
      if (this.rest_offer && this.rest_offer.length > 0) {
        this.rest_offer.forEach((e) => {
          if (
            e.items.includes(Number(itemId)) &&
            this.couponTypes.FLATPRICE == e.coupon_type
          ) {
            final = parseFloat(e.flat_price).toFixed(2);
            return; // if first is only valid - remove return  if last is valid if same item in two diiferent flat price coupon
          } else if (
            e.items.includes(Number(itemId)) &&
            this.couponTypes.FLATPERCENTAGE == e.coupon_type &&
            Number(e.discount_percentage) > 0
          ) {
            final = (
              parseFloat(price) -
              (parseFloat(price) * Number(e.discount_percentage)) / 100
            ).toFixed(2);
            return;
          }
        });
      }
      return final;
    },
    getOfferes(itemId) {
      let array = [];
      this.rest_offer.forEach((e) => {
        if (
          e.items.includes(Number(itemId)) &&
          (this.couponTypes.BOGO == e.coupon_type ||
            this.couponTypes.FREEBIE == e.coupon_type ||
            this.couponTypes.FLATPRICE == e.coupon_type ||
            this.couponTypes.FLATPERCENTAGE == e.coupon_type)
        ) {
          array.push({ ...e, item_id: itemId });
        }
      });
      return array;
    },
    onModalCloseFun(value) {
      this.isAlert = false;
      if (value == "yes") {
        this.$store.commit("product/clearCartItems");
        this.addProductCart(this.tempProduct);
      }
    },

    addProductToCart(product) {
      if (this.freeBie) {
        this.$emit("hideFreeBei", true);
      }
      var checkRestarant = this.cart.find(
        (ele) => ele.restaurant_id == this.restaurantID
      );
      if (this.cart.length) {
        if (checkRestarant) {
          this.addProductCart(product);
        } else {
          this.AlertData = {
            displayMessage:
              this.$t("Your cart contain items from another  ") +
              this.$t(this.$auth && this.$auth.getRestaurantName()) +
              this.$t(" Do you wish to clear cart and start a new order here?"),
            isSetClass: "prdct-modal-cls",
          };
          this.isAlert = true;
          this.tempProduct = product;
          window.$(this.$refs.AlertModal).modal();
        }
      } else {
        this.addProductCart(product);
      }
    },

    addProductCart(product) {
      let savemrp = 0;
      if (product.price < product.mrp) {
        savemrp = product.mrp - product.price;
      }

      let offerArray = [];
      offerArray = this.getOfferes(product.item_id)
      if (!this.freeBie) {
        if (offerArray.length > 0) {
          if (offerArray[0].coupon_type == this.couponTypes.FREEBIE) {
            offerArray.length = 0;
          }
        }
      }
      var AddToCartItemArray = {
        vendor_id: product.vendor_id,
        restaurant_id: product.restaurant_id,
        item_id: product.item_id,
        item_name: product.item_name,
        price: product.price,
        quantity: 1,
        itemTotalQuantity: product.quantity,
        selected_type: [],
        selectCustoizeID: [],
        selectCustoizePrice: [],
        item_type: product.item_type,
        item_price: product.price,
        image: product.image,
        saveprice: savemrp,
        packageCharge: product.packaging_charge,
        offer: offerArray,
      };
      this.$store.dispatch("product/addProductToCart", AddToCartItemArray);
    },

    productModal(item) {
      item.restaurant_on_off = this.restaurant_on_off;
      item.restaurant_id = this.restaurantID;
      this.$emit("openProductDetailModal", item);
    },

    plusItem(product) {
      const cartItemIndex = this.cart.findIndex(
        (item) => parseInt(item.item_id) === parseInt(product.item_id)
      );
      var itemTotalQuantity = this.cart[cartItemIndex].quantity;
      if (itemTotalQuantity < product.quantity) {
        this.$store.commit("product/IncrementItemQuantity", cartItemIndex);
      } else {
        this.$swal("Chowman", "Maximum items reached");
      }
    },

    minusItem(product) {
      const cartItemIndex = this.cart.findIndex(
        (item) => parseInt(item.item_id) === parseInt(product.item_id)
      );
      let totalSmCartID = [];
      this.cart.forEach((item) => {
        if (item.item_id === product.item_id) {
          totalSmCartID.push(item.item_id);
        }
      });
      if (totalSmCartID.length > 1) {
        //alert(this.$t("Please Remove Item From Cart!"));
        this.$swal("Chowman", "Please Remove Item From Cart!");
      } else {
        var itemQuantity = this.cart[cartItemIndex].quantity;
        if (itemQuantity == "1" || itemQuantity == "0") {
          this.deleteProduct(cartItemIndex);
        } else {
          this.$store.commit(
            "product/decrementProductInventary",
            cartItemIndex
          );
        }
      }
      return false;
    },

    deleteProduct: function (index) {
      this.$store.dispatch("product/removeProductFromCart", index);
    },

    checkInCart(itemId) {
      var checkItem = this.cart.find((ele) => ele.item_id == itemId);
      if (checkItem) {
        return false;
      } else {
        return true;
      }
    },

    onImgError() {
      this.imgError = true;
      this.noImgClass = "noImgClass";
    },

    readMore(value) {
      $("#moredesc" + value).toggle(400);
      $("#shortdec" + value).toggle(400);
    },
  },
};
</script>
